import React from 'react';

import { useIntl } from 'react-intl';

import { BarToolTip } from '../BarToolTip';

export function Billing() {
  const { messages } = useIntl();

  return (
    <BarToolTip title={messages.head.billing}>
      <svg
        className="bar__icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        stroke="white"
      >
        <rect
          x="2.5"
          y="4.16675"
          width="15"
          height="11.6667"
          rx="1.66667"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M2.5 7.49992H17.5" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.66699 12.5H8.33366" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.6663 12.5H13.333" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </BarToolTip>
  );
}
